// Error screen (§14.2): version mismatch ("A new version is available — reload"), server full,
// room not found or full on a deep link. A dizzy bean, the message, and one clear way out.
import type { LiveScreen } from '../contracts';
import type { UiDeps } from '../deps';
import { beanIcon } from '../icons';
import { el, setText } from '../ui';
import { button, setLabel } from '../widgets';

export interface ErrorProps { message: string; reload: boolean; title?: string; code?: string }

export function create(deps: UiDeps): LiveScreen {
  const title = el('h2', { class: 'error-title' });
  const message = el('p', { class: 'error-msg' });
  let reload = false;
  const act = button({ label: 'BACK TO MENU', icon: 'back', variant: 'pink', size: 'big', autofocus: true, onClick: () => (reload ? deps.actions.reload() : deps.actions.leave()) });
  return {
    el: el('div', { class: 'screen modal', attrs: { 'data-noback': true } },
      el('div', { class: 'panel hero with-ribbon error-panel springy' },
        el('div', { class: 'ribbon', text: 'UH OH!' }),
        el('div', { class: 'error-bean' }, beanIcon('#FF7AC8', 'dizzy', 'ico')),
        title, message, act)),
    onShow(props) {
      const p = props as ErrorProps;
      reload = p.reload;
      setText(title, p.title ?? (p.reload ? 'Fresh beans available!' : 'That did not work'));
      setText(message, p.message);
      setLabel(act, p.reload ? 'RELOAD' : 'BACK TO MENU');
      deps.services.playUi('error');
    },
  };
}
